import { useController, useFormContext } from 'react-hook-form'
import {
  FormControl,
  FormHelperText,
  InputLabel as MuiInputLabel,
  MenuItem,
  Select as MuiSelect,
} from '@mui/material'

import { DefaultElementProps } from 'common/interfaces'
import InputLabel from 'components/InputLabel'
import { SizingContainer } from 'components/SizingContainer'
import { useTemplate } from 'utils/hook'
import validationsToRules from 'utils/validationsToRules'

import { Select as SelectProps } from './interface'

interface Option {
  label: string
  value: string
}

export default function Select({
  name,
  size,
  label,
  options,
  loading,
  onFocus,
  onChange,
  validations,
  defaultValue,
}: SelectProps & DefaultElementProps): JSX.Element {
  const render = useTemplate()

  const { control } = useFormContext()
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue: render(defaultValue ?? ''),
    rules: validationsToRules(validations),
  })

  return (
    <SizingContainer className="select-wrap" size={size}>
      <FormControl error={error !== undefined} fullWidth>
        <MuiInputLabel id={name}>{label}</MuiInputLabel>
        <MuiSelect
          {...field}
          onChange={(e) => {
            field.onChange(e)
            onChange?.({ value: e.target.value })
          }}
          onFocus={onFocus}
          label={<InputLabel label={label} />}
          labelId={name}
        >
          {loading === true ? (
            <MenuItem key="loading">Loading...</MenuItem>
          ) : (
            options?.map(({ value, label }: Option) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))
          )}
        </MuiSelect>
        {error !== undefined && <FormHelperText>{error.message}</FormHelperText>}
      </FormControl>
    </SizingContainer>
  )
}
